import { Form } from "antd";

export const MatchProfileNumberFormInput = ({ children, ...props }) => (
  <Form.Item normalize={(value) => (value === null ? undefined : value)} {...props}>
    {children}
  </Form.Item>
);
